import React, { ButtonHTMLAttributes, useState } from 'react';
import { Spinner } from '../../utils/Spinner';

interface VetRecButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
    onClick?: ((e: React.MouseEvent) => Promise<void>) | (() => void);
    disabled?: boolean;
    showProcessing?: boolean;
    processingText?: string; 
    spinnerClassName?: string;
    children: React.ReactNode;
}

const VetRecButton: React.FC<VetRecButtonProps> = ({
    onClick,
    children,
    showProcessing,
    processingText,
    disabled,
    spinnerClassName = "",
    ...buttonProps
}) => {
    const [isClicking, setIsClicking] = useState(false);
    const handleClick = onClick ? (e: React.MouseEvent) => {
        const result = onClick(e);
        setIsClicking(true);
        let isSynchronous: boolean = true 
        try {
            if (result instanceof Promise) {
                isSynchronous = false
                result.catch((error: unknown) => {
                    throw error;
                }).finally(() => {
                    setIsClicking(false);
                })
            }    
        } finally {
            if (isSynchronous){
                setIsClicking(false);
            }
        }
    } : undefined;

    return (
        <button
            onClick={handleClick}
            disabled={disabled || isClicking}
            {...buttonProps}
        >
            <div className="flex flex-row gap-x-3 items-center">
                {showProcessing && isClicking && <Spinner size="h-4 w-4" timer={true} className={`fill-blue-400 ${spinnerClassName}`}/>}
                {showProcessing && isClicking && processingText ? processingText : children}
            </div>
        </button>
    );
};

export default VetRecButton;